/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EffectiveLaborCostDto } from '../../models/effective-labor-cost-dto';
import { UpdateEffectiveLaborCostRequest } from '../../models/update-effective-labor-cost-request';

export interface UpdateEffectiveLaborCost$Params {
  id: string;
      body: UpdateEffectiveLaborCostRequest
}

export function updateEffectiveLaborCost(http: HttpClient, rootUrl: string, params: UpdateEffectiveLaborCost$Params, context?: HttpContext): Observable<StrictHttpResponse<EffectiveLaborCostDto>> {
  const rb = new RequestBuilder(rootUrl, updateEffectiveLaborCost.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EffectiveLaborCostDto>;
    })
  );
}

updateEffectiveLaborCost.PATH = '/v0/effectiveLaborCost/{id}';
